import r from '../utils/request'
import { API_ROOT } from '../utils/constants'

// Bulk scan: a box of recipe card photos, read in the background

export const getBatches = () => r.get('/scan-batches')

export const createBatch = () => r.post('/scan-batches')

export const getBatch = (id) => r.get(`/scan-batches/${id}`)

export const uploadBatchPhoto = (id, blob, name) => {
  const form = new FormData()
  form.append('photo', blob, name)
  return r.post(`/scan-batches/${id}/photos`, form)
}

export const startBatch = (id) => r.post(`/scan-batches/${id}/start`)

export const updateDraft = (id, draftId, params) =>
  r.put(`/scan-batches/${id}/drafts/${draftId}`, params)

export const discardDraft = (id, draftId) => r.delete(`/scan-batches/${id}/drafts/${draftId}`)

export const mergeDrafts = (id, draftIds) =>
  r.post(`/scan-batches/${id}/drafts/merge`, { draft_ids: draftIds })

export const splitDraft = (id, draftId) => r.post(`/scan-batches/${id}/drafts/${draftId}/split`)

export const addDrafts = (id, params) => r.post(`/scan-batches/${id}/add`, params)

export const cancelBatch = (id) => r.delete(`/scan-batches/${id}`)

export const batchPhotoUrl = (link) => (link ? `${API_ROOT}${link}` : '')
